import React from 'react';
import { useTranslation } from '@shared/core';
import { TextV2, Flex, InputV2, ButtonV2 } from '@withjoy/joykit';
import { StyledCardWrapper, StyledFormControl, styles, registryGuestCountSaveButtonStyles } from './styles';
import { FormikProps } from 'formik';
import { GuestCountInputFields } from '../../RegistryGiftCounts.controller';
import { pxToRem } from '@withjoy/joykit/theme';

interface EditStateProps {
  formik: FormikProps<GuestCountInputFields>;
  fromAddGifts?: boolean;
}

export const EditState = ({ formik, fromAddGifts = false }: EditStateProps) => {
  const { t } = useTranslation('sharedComponents');
  const { howManyGuests, save } = t('registryGiftCounts');

  if (fromAddGifts) {
    return (
      <Flex gap={7}>
        <Flex flexDirection="column" justifyContent="center" width="100%" alignItems="center">
          <TextV2 fontSize={24} fontWeight={700} marginBottom={2} alignItems="center" lineHeight={1.3}>
            {howManyGuests()}
          </TextV2>
          <TextV2 typographyVariant="body2" color="mono10" fontSize={16} fontWeight={400} marginBottom={4}>
            Not sure? Just guess for now.
          </TextV2>
        </Flex>
        <Flex flexDirection="column" justifyContent="center">
          <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
            <StyledFormControl __css={styles.formControl} isInvalid={!!formik.errors.guestCount}>
              <InputV2 height={pxToRem(80)} {...formik.getFieldProps('guestCount')} />
            </StyledFormControl>

            <ButtonV2 shape="rounded" marginTop={16} type="submit" overrides={registryGuestCountSaveButtonStyles} justifyContent="center" width="100%">
              {save()}
            </ButtonV2>
          </form>
        </Flex>
      </Flex>
    );
  }

  return (
    <StyledCardWrapper __css={styles.cardWrapper}>
      <Flex flexDirection="column" width="100%">
        <TextV2 fontSize={24} fontWeight={700} marginBottom={2} alignItems="center">
          {howManyGuests()}
        </TextV2>
        <TextV2 typographyVariant="body2" color="mono10" fontSize={16} fontWeight={400} marginBottom={4} alignItems="center">
          Not sure? Just guess for now.
        </TextV2>
      </Flex>
      <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
        <StyledFormControl __css={styles.formControl} isInvalid={!!formik.errors.guestCount}>
          <InputV2 height={pxToRem(120)} {...formik.getFieldProps('guestCount')} />
        </StyledFormControl>

        <ButtonV2 shape="rounded" marginTop={16} type="submit" overrides={registryGuestCountSaveButtonStyles}>
          {save()}
        </ButtonV2>
      </form>
    </StyledCardWrapper>
  );
};
